import { useMemo } from "react";
import PropTypes from "prop-types";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Text } from "@shopify/polaris";
import Stack from "../Stack";
import Iconify from "../Iconify";
import { useAppBridge } from "@shopify/app-bridge-react";

TitleBar.propTypes = {
  breadcrumb: PropTypes.object,
  action: PropTypes.node,
  heading: PropTypes.string,
  isDirty: PropTypes.bool,
  isLoading: PropTypes.bool,
  shopify: PropTypes.object,
};

export default function TitleBar({ breadcrumb: link = {}, action, heading }) {
  const { name, href } = link;
  const navigate = useNavigate();
  const shopify = useAppBridge();

  const handleBackClick = () => {
    shopify.saveBar
      .leaveConfirmation()
      .then(() => {
        navigate(href || -1);
      })
      .catch((error) => {
        console.log("save bar error ", error);
      });
  };

  const breadcrumb = useMemo(
    () =>
      name && href ? (
        <RouterLink
          key={name}
          variant="breadcrumb"
          to={href || "#"}
          onClick={(e) => {
            e.preventDefault();
            handleBackClick();
          }}
          style={{ display: "flex" }}
        >
          <Iconify icon="eva:arrow-back-fill" style={{ width: "20px", height: "20px", color: "#000" }} />
        </RouterLink>
      ) : null,
    [name, href, shopify]
  );

  return (
    <Stack justifyContent="space-between" alignItems="center" style={{ marginBottom: "24px" }}>
      <Stack spacing="4px" alignItems="center">
        {breadcrumb}
        <Text variant="headingLg" fontWeight="bold">
          {heading}
        </Text>
      </Stack>
      {action}
    </Stack>
  );
}
